<template>
  <AssessmentForm @submit="onSubmit" class="location-step" :disabled="!location || isLoading">
    <template slot="header">
      <div>Welcome</div>
      <div>We’ll help you search for the Services you need</div>
    </template>
    <template slot="description">
      <p>
        We use your location to help match available services that are closest
        to you
      </p>
    </template>
    <LocationInput @change="onLocationInput" />
  </AssessmentForm>
</template>

<script>
import AssessmentForm from '@/components/assessment-form';
import LocationInput from '@/components/location-input';
import Vue from 'vue';
import get from 'lodash';
import { saveLocation, saveCity } from '@/store';

export default {
  components: {
    AssessmentForm,
    LocationInput,
  },
  data() {
    return { isLoading: false, location: null };
  },
  methods: {
    onLocationInput(result) {
      this.location = result;
    },
    async onSubmit() {
      if (!this.location || this.isLoading) return;
      this.isLoading = true;
      await this.saveAddress(this.location);
      this.isLoading = false;
      this.$emit('submit');
    },
    async saveAddress() {
      const location = this.location.place_name;
      const center = this.location.center;
      if (center?.length) {
        await saveLocation({
          lng: center[0],
          lat: center[1],
        });
      }

      await saveCity(location || '');
    },
  },
};
</script>

<style lang="scss" scoped>
// TODO(jjandoc): Update the base LocationInput with these styles to remove
// copy-and-pasted code from PatientCare.vue.
.location-step /deep/ {
  .search-results {
    background: var(--white);
    border-radius: 10px;
    color: var(--black);
    margin-top: 12px;
    padding: 0;
  }

  .address-list-item {
    align-items: flex-start;
    border-color: var(--off-white);
    display: flex;
    padding: 12px 32px 12px 16px;
  }

  .arrow {
    right: 16px;
  }

  .prediction:first-of-type .address-list-item {
    border-top: 0;
  }
}
</style>
